var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCustomizeMetal',{attrs:{"componentCode":"AM"},scopedSlots:_vm._u([{key:"respect",fn:function({ text }){return [_c('div',{staticClass:"text"},[_c('span',{domProps:{"innerHTML":_vm._s(text.split('')[0] || '')}}),_c('span',{domProps:{"innerHTML":_vm._s(text.split('')[1] || '')}})])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }